/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Scan_BodyInputs */

const en_features_scan_body = /** @type {(inputs: Features_Scan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Point the camera at your plate and the app sees what is on it, then counts the calories, protein, carbs and fat next to your coach's target.`)
};

const pl_features_scan_body = /** @type {(inputs: Features_Scan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skieruj aparat na talerz, a aplikacja rozpozna, co na nim leży, i policzy kalorie, białko, węglowodany i tłuszcze obok celu od trenera.`)
};

/**
* | output |
* | --- |
* | "Point the camera at your plate and the app sees what is on it, then counts the calories, protein, carbs and fat next to your coach's target." |
*
* @param {Features_Scan_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_scan_body = /** @type {((inputs?: Features_Scan_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Scan_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_scan_body(inputs)
	return en_features_scan_body(inputs)
});